import { InjectionToken } from '@angular/core';
export var BF_AUTH_CONFIG = new InjectionToken('bfAuthConfig');
export var BF_AUTH_CONFIG_OPTIONS = new InjectionToken('bfAuthConfigOptions');
